import icon from 'vue-svgicon';

icon.register({
    'regular/cog-browser': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M15.75 21.751H21a1.5 1.5 0 0 0 1.5-1.5v-16.5a1.5 1.5 0 0 0-1.5-1.5H3a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h5.25M1.5 6.001h21" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle pid="1" cx="12" cy="14.701" r="3.75" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="2" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 10.951v-1.8M12 20.251v-1.8M15.75 14.701h1.8M6.45 14.701h1.8M8.459 10.742l1.107 1.106M15.541 10.742l-1.107 1.106M8.459 18.66l1.107-1.107M15.541 18.66l-1.107-1.107M12 13.951a.75.75 0 1 1-.75.75.75.75 0 0 1 .75-.75"/>`,
    },
});
